// state
export const state = {
  favorites: [],
};

// getters
export const getters = {

};

// mutations
export const mutations = {
  /**
   * Set all the favorites into the state
   * @param state
   * @param data
   */
  commitFavorites(state, data) {
    state.favorites = data;
  },
};

// actions
export const actions = {
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
